/** Build tel: href from display phone string */
export function telHref(phone: string): string {
  const d = phone.replace(/\D/g, '')
  if (d.length === 10) return `tel:+1${d}`
  if (d.length >= 11) return `tel:+${d}`
  return `tel:${phone.trim()}`
}
